import { useEffect, useState } from "react";
import { set, useForm } from "react-hook-form";
import { FaFilePdf, FaYoutube } from "react-icons/fa";
import Select from "react-select";
import { toast } from "react-toastify";
import { Badge, Form, Label } from "reactstrap";
import {
  createEContentAPI,
  deleteEContentAPI,
  getChapterBySubjectAndClassDD,
  getClassDD,
  getEContentAPI,
  getLMSSubjectSpecificChapterAPI,
  getSessionDD,
  getStreamByClassDD,
  getSubjectByClassLMSDD,
  updateEContentAPI,
} from "../../../api/LMS/master";
import { BASE_URL_IMG_LMS, contentTypeList } from "../../../assets/constants/constants";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  PreviewAltCard,
  Row,
} from "../../../components/Component";
import useLogout from "../../../hooks/useLogout";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
import MyDataTable from "../../../myComponents/DataTable/MyDataTable";
import MyButton from "../../../myComponents/form/MyButton";
import PdfUpload from "../../../myComponents/form/PdfUpload";
import Status from "../../../myComponents/form/Status";
import ConfirmModal from "../../../myComponents/modals/ConfirmModal";
import ViewImgAndPdf from "../../../myComponents/modals/ViewImgAndPdf";
import Required from "../../../myComponents/validate/Required";
import { decrypt, encrypt } from "../../../utils/Encrypt";
import { ValidateImg, ValidateImgWithSize, ValidatePdf, ValidateThumbWithSize } from "../../../utils/Utils";
import { DeleteModal } from "../../../myComponents/modals/DeleteModal";
import ImageUpload from "../../../myComponents/form/ImageUpload";
import { useLocation, useNavigate } from "react-router";
import { hasPermission } from "../../../utils/myFunctions";

const Index = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isPDFModal, setIsPDFModal] = useState(false);
  const [isVideoModal, setIsVideoModal] = useState(false);
  const [mode, setMode] = useState("Add");
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
    const location = useLocation();
    const navigate = useNavigate();
    const enc = JSON.parse(localStorage.getItem("userDetail"));
    const user = decrypt(enc?.data || []);
    const isView = hasPermission(user, location?.pathname, "isView");
    const isUpdate = hasPermission(user, location?.pathname, "isUpdate");
    const isDelete = hasPermission(user, location?.pathname, "isDelete");
    const isCreate = hasPermission(user, location?.pathname, "isCreate"); 
      const [timer, setTimer] = useState(5); // 5 seconds countdown
      useEffect(() => {
        if (!isView) {
          const interval = setInterval(() => {
            setTimer((prevTimer) => prevTimer - 1);
          }, 1000);
          // redirect to home page when the timer reaches 0
          if (timer === 0) {
            navigate(-1);
          }
          // clean up the interval when the component unmounts
          return () => clearInterval(interval);
        } else {
          setIsLoading(false);
        }
      }, [timer]);
  const logout = useLogout();
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    setError,
    clearErrors,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      status: null,
      streamList: [],
      mode: "Add",
      pdf_file_url: null,
      deleteModal: false,
      rowDelete: null,
      thumbnail: null,
      thumbnail_url: null,
    },
  });

  const [modalImages, setModalImages] = useState([]);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);
  const [titleName, setTitleName] = useState("");
  const [fileType, setFileType] = useState("");
  const toggleImageModal = () => {
    setModalOpen(true);
  };
  const toggleModal = () => {
    setModalOpen(!modalOpen);
  };

  const getFileTypeFromUrl = (url) => {
    if (typeof url !== "string") return "";
    if (url.includes("youtube.com") || url.includes("youtu.be")) {
      return "youtube";
    }
    const fileExtension = url.split(".").pop().split(/#|\?/)[0];
    return fileExtension.toLowerCase();
  };

  // const handleImageClick = (index, image, inputName, passedFileType) => {
  //   setCurrentImageIndex(index);
  //   setTitleName(inputName);
  //   const fileType = passedFileType || getFileTypeFromUrl(image);
  //   setFileType(fileType);
  //   if (fileType === "pdf") {
  //     setModalImages([image]); // PDF file
  //   } else if (fileType === "youtube") {
  //     console.log("This is a YouTube link:", image);
  //     setModalImages([image]); // Set the YouTube URL
  //   } else {
  //     setModalImages([image]); // Image file
  //   }
  //   toggleImageModal(); // Open the modal
  // };

  const handleImageClick = (a, b) => {
    if (a?.content_type == "E-Book" || a.content_type == "Video") {
      setIsPDFModal(true);
      setValue("image_url", b);
      setValue("chapter_name", a?.chapter_name || "");
    }
    const image = watch("image_url");
    const fileType = getFileTypeFromUrl(image);

    setFileType(fileType);
    if (fileType === "pdf") {
      setModalImages([image]); // PDF file
    } else if (fileType === "youtube") {
      console.log("This is a YouTube link:", image);
      setModalImages([image]); // Set the YouTube URL
    } else {
      setModalImages([image]); // Image file
    }
    toggleImageModal(); // Open the modal
  };

  const [data, setData] = useState([]);
  const [classList, setClassList] = useState([]);
  const [subjectList, setSubjectList] = useState([]);
  const [sessionList, setSessionList] = useState([]);
  const [chapterList, setChapterList] = useState([]);
  const [columns, setColumns] = useState([
    {
      name: "Session",
      selector: (row) => row?.session,
      sortable: true,
    },
    {
      name: "Class",
      selector: (row) => row?.class,
      sortable: true,
      wrap: true,
    },
    {
      name: "Stream",
      selector: (row) => row?.stream_name,
      sortable: true,
      wrap: true,
    },
    {
      name: "Subject",
      selector: (row) => row?.subject,
      sortable: true,
      wrap: true,
    },
    {
      name: "Chapter",
      selector: (row) => row?.chapter_name,
      sortable: true,
      wrap: true,
    },
    {
      name: "Volume",
      selector: (row) => (row?.volume == "null" ? "" : row?.volume),
      sortable: true,
    },
    {
      name: "Content Type",
      selector: (row) => row?.content_type,
      sortable: true,
    },
    {
      name: "Content Language",
      selector: (row) => row?.language,
      sortable: true,
    },
    {
      name: "Thumbnail",
      selector: (row) => (
        <div>{row?.thumbnail && <img style={{width: "40px", height: "auto"}} src={`${BASE_URL_IMG_LMS}${row?.thumbnail}`} alt="Thumbnail" />}</div>
      ),
      sortable: true,
    },
    {
      name: "Document",
      selector: (row) => row?.document,
      wrap: true,
      cell: (row) => {
        const fileUrl = row?.content_type === "E-Book" ? `${BASE_URL_IMG_LMS}${row?.document}` : `${row?.document}`;
        const getFileTypeFromUrl = (url) => {
          const fileExtension = url.split(".").pop().split(/#|\?/)[0];
          return fileExtension.toLowerCase();
        };
        return (
          <div className="upload-image-div my-2">
            <Button
              outline
              id={`doc-${row.id}`}
              color="danger"
              type="button"
              onClick={() => handleImageClick(row, fileUrl)}
              size="xxl"
              data-toggle="tooltip"
              data-placement="top"
              title="View Document"
              className="mb-2"
            >
              {row?.content_type === "E-Book" ? (
                <FaFilePdf style={{ height: "1rem", width: "1rem" }} />
              ) : (
                <FaYoutube style={{ height: "1rem", width: "1rem" }} />
              )}
            </Button>
          </div>
        );
      },
    },
    {
      name: "Status",
      selector: (row) => row?.status,
      cell: (row) => (
        <div style={{ cursor: "pointer" }} onClick={() => handleToggleStatus(row)}>
          <Badge color={`${row.status == "active" ? "success" : "danger"}`}>
            {row.status == "active" ? "Active" : "Inactive"}
          </Badge>
        </div>
      ),
      sortable: true,
      wrap: true,
    },
    {
      name: "Action",
      wrap: true,
      cell: (row) => (
        <div>
         {isUpdate && <Button outline color={`warning`} size={`xs`} className={`me-1`} onClick={() => handleEdit(row)}>
            {" "}
            <Icon name="edit" />
          </Button>}
          {isDelete && <Button outline color={`danger`} size={`xs`} className={`me-1`} onClick={() => deleteToggle(row)}>
            {" "}
            <Icon name="trash" />
          </Button>}
        </div>
      ),
    },
  ]);
  const handleToggleStatus = (row) => {
    setSelectedRow(row);
    setShowModal(true);
  };

  useEffect(() => {
    getClass();
    getSession();
    getEContent();
    if(user?.role=="Subject Specialist"){
      getSubjectSpecialistSubjects()
    }
  }, []);

  const getSubjectSpecialistSubjects = () => {
    const data = {};
    getLMSSubjectSpecificChapterAPI(data)
      .then((res) => {
        // decrypt data
        const status = res.data.status;
        // const status = decrypt(res.data.status);
        if (status === true) {
          // const decryptedResponse = decrypt(res.data.data.tableData);
          setChapterList(res.data.data);
          toast.clearWaitingQueue();
        } else if (status === false) {
          toast.clearWaitingQueue();
          setChapterList([]);
        } else if (status === "expired") {
          toast.error(res.data.message);
          logout();
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };
  const getSession = () => {
    const data = {};
    getSessionDD(data)
      .then((res) => {
        // decrypt data
        const status = res.data.status;
        // const status = decrypt(res.data.status);
        if (status === true) {
          // const decryptedResponse = decrypt(res.data.data.tableData);
          setSessionList(res.data.data);
          toast.clearWaitingQueue();
        } else if (status === false) {
          toast.clearWaitingQueue();
          setSessionList([]);
        } else if (status === "expired") {
          toast.error(res.data.message);
          logout();
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };
  const getClass = () => {
    const data = {};
    getClassDD(data)
      .then((res) => {
        // decrypt data
        const status = res.data.status;
        // const status = decrypt(res.data.status);
        if (status === true) {
          // const decryptedResponse = decrypt(res.data.data.tableData);
          setClassList(res.data.data);
          toast.clearWaitingQueue();
        } else if (status === false) {
          toast.clearWaitingQueue();
          setClassList([]);
        } else if (status === "expired") {
          toast.error(res.data.message);
          logout();
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };
  const getEContent = () => {
    setIsLoading(true);
    const data = {};
    getEContentAPI(data)
      .then((res) => {
        const status = res.data.status;
        // const status = decrypt(res.data.status);
        if (status === true) {
          // const decryptedResponse = decrypt(res.data.data.tableData);
          setData(res.data.data);
          setIsLoading(false);
          toast.clearWaitingQueue();
        } else if (status === false) {
          toast.clearWaitingQueue();
          setData([]);
          setIsLoading(false);
        } else if (status === "expired") {
          toast.error(res.data.message);
          logout();
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };
  const handleSessionChange = (sel) => {
    setValue("session", sel);
    trigger("session");
  };
  const handleContentTypeChange = (sel) => {
    setValue("content_type", sel);
    trigger("content_type");
  };
  const handleContentLanguageChange = (sel) => {
    setValue("language", sel);
    trigger("language");
  };
  const handleSubjectChange = (selectedOption) => {
    setValue("subject", selectedOption || "");
    trigger("subject");
    setValue("chapter", "");
    // trigger("chapter");
    setChapterList([]);
    const body = {
      class_id: watch("class")?.value,
      subject_id: selectedOption?.value,
    };
    getChapterBySubject(body);
  };
  const getChapterBySubject = (body) => {
    getChapterBySubjectAndClassDD(body)
      .then((res) => {
        const status = res.data.status;
        if (status === true) {
          setChapterList(res.data.data);
        } else if (status === false) {
          setChapterList([]);
        } else if (status === "expired") {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        console.log("Err", err);
      });
  };
  const handleClassChange = (selectedOption) => {
    setValue("class", selectedOption || "");
    trigger("class");
    if (watch("mode") == "Add") {
      setValue("stream", "");
      setValue("subject", "");
      // trigger("subject");
      setValue("chapter", "");
      // trigger("chapter");
      setSubjectList([]);
      setChapterList([]);
    }
    const body = {
      class_id: selectedOption?.value,
    };
    if (selectedOption?.value == "1"||selectedOption?.value=="4") {
      getSubjectByClass(body);
    }
    if (selectedOption?.value == "2"||selectedOption?.value == "3") {
      getStreamByClass(body);
    }
  };

  const handleChapterChange = (selectedOption) => {
    setValue("chapter", selectedOption || "");
    trigger("chapter");
  };
  const getSubjectByClass = (body) => {
    getSubjectByClassLMSDD(body)
      .then((res) => {
        const status = res.data.status;
        if (status === true) {
          setSubjectList(res.data.data);
        } else if (status === false) {
          setSubjectList([]);
        } else if (status === "expired") {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        console.log("Err", err);
      });
  };
  const onFormSubmit = (data) => {
    const formData = new FormData(); 
    formData.append("session", data?.session?.value);
    if(user?.role=="Subject Specialist"){
      formData.append("class_id", user.class_id);
      formData.append("subject", user.subject_id);
    }else{
       formData.append("class_id", data.class?.value);
      formData.append("subject", data.subject?.value);
    }
      
    formData.append("chapter_id", data?.chapter?.value);
    formData.append("content_type", data?.content_type?.value);
    formData.append("status", data?.status?.value);
    formData.append("language", data?.language?.value);
    formData.append("volume", data?.volume);
    if (mode == "Edit") {
      formData.append("id", watch("id"));
    }
    if (watch("content_type")?.value == "Video" && watch("pdf_file_url") == null) {
      formData.append("url", data?.url);
    }
    if (watch("content_type")?.value == "E-Book" && watch("pdf_file_url") != null) {
      formData.append("pdf_file", data?.pdf_file);
    } else if (watch("content_type")?.value == "E-Book" && watch("pdf_file_url") == null) {
      formData.append("pdf_file", data?.banner_image);
    }
if(user?.role=="Subject Specialist"){

    if ((watch("class")?.value == 2||watch("class")?.value == 3)) {
      formData.append("stream_id",user?.stream_id);
    }
}else{
   if ((watch("class")?.value == 2||watch("class")?.value == 3)) {
      formData.append("stream_id", data?.stream?.value);
    }
}
    if (watch("thumbnail_url") == null) {
      formData.append("thumbnail", null);
    } else {
      formData.append("thumbnail", data?.thumbnail);
    }
    if (mode === "Add") {
      createEContentAPI(formData)
        .then((res) => {
          const status = res.data.status;
          if (status === true) {
            setValue("pdf_file_url", null);
            setValue("thumbnail_url", null);
            setValue("thumbnail", null);
            toast.success(res.data.message);
            toast.clearWaitingQueue();
            getEContent();
            setIsOpen(false);
            setIsLoading(false);
          } else if (status === false) {
            setIsLoading(false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
          } else if (status === "expired") {
            setIsLoading(false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
            logout();
          }
        })
        .catch((err) => {
          setIsLoading(false);
          toast.error(err.message);
        });
    }
    if (mode === "Edit") {
      updateEContentAPI(formData)
        .then((res) => {
          const status = res.data.status;
          if (status === true) {
            setValue("pdf_file_url", null);
            setValue("thumbnail_url", null);
            setValue("thumbnail", null);
            toast.success(res.data.message);
            toast.clearWaitingQueue();
            getEContent();
            setIsOpen(false);
            setIsLoading(false);
          } else if (status === false) {
            setIsLoading(false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
          } else if (status === "expired") {
            setIsLoading(false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
            logout();
          }
        })
        .catch((err) => {
          setIsLoading(false);
          toast.error(err.message);
        });
    }
  };
  const handleEdit = (row) => {
    window.scrollTo(0, 0);
    console.log("row data", row);

    setIsOpen(!isOpen);
    setMode("Edit");
    setValue("id", row.id); // Add this for consistent `formData` structure
    setValue("subject", {
      label: row?.subject,
      value: row?.subjectId,
    });
    trigger("subject");
    // setValue("subject_code", row?.subject_code);
    setValue("volume", row.volume == "null" ? "" : row?.volume);
    // setValue("order", row.order);
    setValue("status", {
      label: row.status == "active" ? "Active" : "Inactive",
      value: row.status,
    });
    setValue("class", {
      label: row.class,
      value: row.classId,
    });
    setValue("chapter", {
      value: row?.chapterId,
      label: row?.chapter_name,
    });
    setValue("language", {
      label: row.language,
      value: row.language,
    });
    setValue("content_type", {
      label: row.content_type,
      value: row.content_type,
    });
    setValue("session", {
      label: row.session,
      value: row.sessionId,
    });
    if (row?.thumbnail != "null" && row?.thumbnail != null) {
      setValue("thumbnail_url", BASE_URL_IMG_LMS + row?.thumbnail);
    }
    if (row?.content_type == "Video") {
      setValue("url", row?.document);
    }
    if (row?.content_type == "E-Book") {
      setValue("pdf_file_url", BASE_URL_IMG_LMS + row?.document);
      setValue("pdf_file_type", "application/pdf");
    }
    const body = {
      class_id: row.classId,
    };
    const payload = {
      subject_id: row.subjectId,
    };
    if (row?.classId == 1||row?.classId==4) {
      getSubjectByClass(body);
      getChapterBySubject(payload);
    }
    if (row?.classId == 2 || row?.classId == 3) {
      const body = {
        value: row?.classId,
        label: row?.class,
      };
      handleClassChange(body);
      const payload = {
        value: row?.stream_id,
        label: row?.stream_name,
      };

      handleStreamChange(payload);

      const data = {
        label: row?.subject,
        value: row?.subjectId,
        class_id: row?.classId,
        stream_id: row?.stream_id,
      };
      handleSubjectChange(data);
      setValue("chapter", {
        value: row?.chapterId,
        label: row?.chapter_name,
      });
    }
  };
  const handleFileChange = (e, errorInput, url) => {
    const file = e.target.files[0];
    if (file) {
      ValidatePdf(file, (isValid, message) => {
        if (isValid) {
          setValue(errorInput, file); // Set as File object, not string
          const imageUrl = URL.createObjectURL(file);
          setValue(url, imageUrl);
          trigger(errorInput);
          console.log("jhjhjhjh", file);
          setTimeout(() => clearErrors(errorInput), 100);
        } else {
          setError(errorInput, {
            type: "manual",
            message: message,
          });
          e.target.value = "";
        }
      });
    } else {
      setValue(errorInput, "");
    }
  };
  const confirmStatusChange = () => {
    const updatedStatus = selectedRow.status === "active" ? "inactive" : "active";
    const formObject = {
      id: selectedRow.id,
      status: updatedStatus,
    };

    const encryptedData = encrypt(formObject);
    const encryptData = {
      zero: encryptedData,
    };
    updateEContentAPI(formObject)
      .then((res) => {
        // decrypt data
        // const status = decrypt(res.data.status);
        const status = res.data.status;
        if (status === true) {
          getEContent();

          setShowModal(false);
          toast.success(res.data.message);
          toast.clearWaitingQueue();
        } else if (status === false) {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (status === "expired") {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => console.error("Error updating status:", err));
  };

  const handleStreamChange = (selectedOption) => {
    setValue("stream", selectedOption || "");
    trigger("stream");
    if (watch("mode") == "Add") {
      setValue("subject", "");
      setValue("chapter", "");
    }
    const body = {
      class_id: watch("class")?.value,
      stream_id: watch("stream")?.value,
    };
    getSubjectByClass(body);
  };
  const getStreamByClass = (data) => {
    getStreamByClassDD(data)
      .then((res) => {
        // decrypt data
        const status = res.data.status;
        // const status = decrypt(res.data.status);
        if (status === "expired") {
          setValue("streamList", []);
          toast.error(res.data.message);
          logout();
        } else if (status === true) {
          toast.success(res.data.message);
          setValue("streamList", res.data.data);
          toast.clearWaitingQueue();
        } else {
          toast.warning(res.data.message);
          setValue("streamList", []);
          toast.clearWaitingQueue();
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };
  const togglePDFModal = () => {
    setIsPDFModal((pre) => !pre);
  };
  const deleteToggle = (row) => {
    setValue("rowDelete", row);
    setValue("deleteModal", true); 
  };
  const handleRowDelete = () => {
    const body = {
      id: watch("rowDelete")?.id,
    };
    deleteEContentAPI(body)
      .then((res) => {
        const status = res.data.status;
        if (status === true) {
          toast.success(res.data.message);
          toast.clearWaitingQueue();
          getEContent();
          setValue("deleteModal", false);
          setIsLoading(false);
        } else if (status === false) {
          setIsLoading(false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (status === "expired") {
          setIsLoading(false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setIsLoading(false);
        toast.error(err.message);
      });
  };
  const handleImageChange = (e, errorInput, url) => {
    const file = e.target.files[0];
    if (file) {
      ValidateThumbWithSize(file, (isValid, message) => {
        if (isValid) {
          setValue(errorInput, file); // Set as File object, not string
          const imageUrl = URL.createObjectURL(file);
          setValue(url, imageUrl);
          trigger(errorInput);
          setTimeout(() => clearErrors(errorInput), 100);
        } else {
          setError(errorInput, {
            type: "manual",
            message: message,
          });
          e.target.value = "";
        }
      });
    } else {
      setValue(errorInput, "");
    }
  };

  console.log("user--->",user)
  return (
    <>
      <Head title={"E-Content"} />
      <Content>

         {!isView ? (
          <div className="p-5" style={{}}>
            <p style={{ color: "crimson", textAlign: "center" }}>{"Unauthorized"}</p>
            <p style={{ textAlign: "center" }}>
              You will be redirected to the home page in <b style={{ color: "crimson" }}>{timer} </b> seconds.
            </p>
          </div>
        ) : (
       <>
        <BlockHead size={`sm`}>
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                {"E-Content"}
              </BlockTitle>
            </BlockHeadContent>
            {isCreate && <BlockHeadContent>
              <div className="">
                <Button
                  color="primary"
                  outline
                  className={`  me-n1`}
                  onClick={() => {
                    setIsOpen(!isOpen);
                    setMode("Add");
                    reset();
                  }}
                >
                  {<Icon name={isOpen ? "minus" : "plus"} />}
                </Button>
              </div>
            </BlockHeadContent>}
          </BlockBetween>
        </BlockHead>
        <Block>
          <Row className={`g-gs`}>
            {isOpen && (
              <PreviewAltCard>
                <Form onSubmit={handleSubmit(onFormSubmit)}>
                  <Row className={`g-gs`}>
                    {/* Session */}
                    <Col md={`2`}>
                      <div className="form-group">
                        <Label className="from-label" htmlFor="session">
                          Session
                          <Required />
                        </Label>
                        <div className="form-control-wrap">
                          <Select
                            className=""
                            id="session"
                            options={sessionList}
                            {...register("session", {
                              required: "Please select session",
                            })}
                            onChange={handleSessionChange}
                            value={watch("session")}
                          />
                          {errors.session && <span className="invalid">{errors?.session?.message}</span>}
                        </div>
                      </div>
                    </Col>
                    {/* Class */}
                  {user?.role=="Subject Specialist"?null:  <Col md={`2`}>
                      <div className="form-group">
                        <Label className="from-label" htmlFor="class">
                          Class
                          <Required />
                        </Label>
                        <div className="form-control-wrap">
                          <Select
                            className=""
                            id="class"
                            options={classList}
                            {...register("class", {
                              required: "Please select class",
                            })}
                            onChange={handleClassChange}
                            value={watch("class")}
                          />
                          {errors.class && <span className="invalid">{errors?.class?.message}</span>}
                        </div>
                      </div>
                    </Col>}
                    {/* Stream */}
                  {user?.role=="Subject Specialist"? null:<>  {(watch("class")?.value == "2" ||watch("class")?.value == "3")&& (
                      <Col md={`2`}>
                        <div className="form-group">
                          <Label className="from-label" htmlFor="stream">
                            Stream
                            <Required />
                          </Label>
                          <div className="form-control-wrap">
                            <Select
                              className=""
                              id="stream"
                              options={watch("streamList")}
                              {...register("stream", {
                                required: "Please select stream",
                              })}
                              onChange={handleStreamChange}
                              value={watch("stream")}
                            />
                            {errors.stream && (
                              <span
                                className="invalid"
                                style={{
                                  color: "#e85347",
                                  fontSize: "11px",
                                  fontStyle: "italic",
                                }}
                              >
                                {errors?.stream?.message}
                              </span>
                            )}
                          </div>
                        </div>
                      </Col>
                    )}</>}
                    {/* Subject */}
                    {user?.role=="Subject Specialist"?null:<Col md={`2`}>
                      <div className="form-group">
                        <Label className="from-label" htmlFor="subject">
                          Subject
                          <Required />
                        </Label>
                        <div className="form-control-wrap">
                          <Select
                            className=""
                            id="subject"
                            options={subjectList}
                            {...register("subject", {
                              required: "Please select subject",
                            })}
                            onChange={handleSubjectChange}
                            value={watch("subject")}
                          />
                          {errors.subject && <span className="invalid">{errors?.subject?.message}</span>}
                        </div>
                      </div>
                    </Col>}
                    {/* Chapter */}
                    <Col md={`4`}>
                      <div className="form-group">
                        <Label className="from-label" htmlFor="chapter">
                          Chapter
                          <Required />
                        </Label>
                        <div className="form-control-wrap">
                          <Select
                            className=""
                            id="chapter"
                            options={chapterList}
                            {...register("chapter", {
                              required: "Please select chapter",
                            })}
                            onChange={handleChapterChange}
                            value={watch("chapter")}
                          />
                          {errors.chapter && <span className="invalid">{errors?.chapter?.message}</span>}
                        </div>
                      </div>
                    </Col>
                    {/*Volume*/}
                    <Col md="4" sm="3" xxl="2">
                      <div className="form-group">
                        <Label className="form-label" htmlFor="volume">
                          {"Volume"}
                        </Label>
                        <div className="form-control-wrap">
                          <input
                            placeholder={"Enter volume"}
                            type="text"
                            id="volume"
                            {...register("volume")}
                            className="form-control"
                            value={watch("volume")}
                            onChange={(e) => {
                              // let value = e.target.value.replace(/[^A-Za-z\s]/g, ""); // Remove invalid characters
                              // value = value.replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
                              setValue("volume", e.target.value);
                              trigger("volume"); // Trigger validation
                            }}
                            // onInput={(e) => {
                            //   e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, "");
                            // }}
                          />
                          {errors.volume && <span className="invalid">{errors?.volume?.message}</span>}
                        </div>
                      </div>
                    </Col>{" "}
                    {/* Type of content */}
                    <Col md={`2`}>
                      <div className="form-group">
                        <Label className="from-label" htmlFor="content_type">
                          Content Type
                          <Required />
                        </Label>
                        <div className="form-control-wrap">
                          <Select
                            className=""
                            id="content_type"
                            options={contentTypeList}
                            {...register("content_type", {
                              required: "Please select content type",
                            })}
                            onChange={handleContentTypeChange}
                            value={watch("content_type")}
                          />
                          {errors.content_type && <span className="invalid">{errors?.content_type?.message}</span>}
                        </div>
                      </div>
                    </Col>{" "}
                    {/* Content Language */}
                    <Col md={`2`}>
                      <div className="form-group">
                        <Label className="from-label" htmlFor="language">
                          Content Language
                          <Required />
                        </Label>
                        <div className="form-control-wrap">
                          <Select
                            className=""
                            id="language"
                            options={[
                              { value: "Hindi", label: "Hindi" },
                              { value: "English", label: "English" },
                              { value: "Sanskrit", label: "Sanskrit" },
                              { value: "Urdu", label: "Urdu" },
                            ]}
                            {...register("language", {
                              required: "Please select content type",
                            })}
                            onChange={handleContentLanguageChange}
                            value={watch("language")}
                          />
                          {errors.language && <span className="invalid">{errors?.language?.message}</span>}
                        </div>
                      </div>
                    </Col>{" "}
                    {/*Chapter Name */}
                    {watch("content_type")?.value == "Video" && (
                      <Col md="4" sm="3" xxl="6">
                        <div className="form-group">
                          <Label className="form-label" htmlFor="url">
                            {"Video URL"}
                            <Required />
                          </Label>
                          <div className="form-control-wrap">
                            <input
                              placeholder={"Enter video url"}
                              type="text"
                              id="url"
                              {...register("url", {
                                required: {
                                  value: true,
                                  message: "video url is required",
                                },
                                pattern: {
                                  value: /^https:\/\/[^\s/$.?#].[^\s]*$/,
                                  message: "Enter correct url",
                                },
                                minLength: {
                                  value: 10,
                                  message: "video url must be at least 10 characters long",
                                },
                                maxLength: {
                                  value: 150,
                                  message: "video url cannot exceed 150 characters",
                                },
                              })}
                              className="form-control"
                              value={watch("url")}
                              onChange={(e) => {
                                // let value = e.target.value.replace(/[^A-Za-z\s]/g, ""); // Remove invalid characters
                                // value = value.replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
                                setValue("url", e.target.value);
                                trigger("url"); // Trigger validation
                              }}
                              // onInput={(e) => {
                              //   e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, "");
                              // }}
                            />
                            {errors.url && <span className="invalid">{errors?.url?.message}</span>}
                          </div>
                        </div>
                      </Col>
                    )}
                    {watch("content_type")?.value == "E-Book" && (
                      <PdfUpload
                        handleImageChange={handleFileChange}
                        register={register}
                        errors={errors}
                        setValue={setValue}
                        setError={setError}
                        clearErrors={clearErrors}
                        watch={watch}
                        label="PDF File"
                        image="pdf_file"
                        image_url="pdf_file_url"
                        validate={true} // Enable validation
                        required
                      />
                    )}
                    <ImageUpload
                      handleImageChange={handleImageChange}
                      watch={watch}
                      register={register}
                      errors={errors}
                      setValue={setValue}
                      setError={setError}
                      clearErrors={clearErrors}
                      label={"Thumbnail"}
                      image="thumbnail"
                      image_url="thumbnail_url"
                    />
                    {/* Status */}
                    <Col md="2" sm="3" xxl="2">
                      <Status setValue={setValue} trigger={trigger} register={register} watch={watch} errors={errors} />
                    </Col>
                  </Row>
                  <Col md="2" className={``}>
                    <MyButton isLoading={isLoading} mode={mode} />
                  </Col>
                </Form>
              </PreviewAltCard>
            )}
            <MyDataTable data={data} columns={columns} title={"Subject"} isLoading={isLoading} />
          </Row>
        </Block>
       </>)}
      </Content>
      {/* Confirmation Modal */}
      <ConfirmModal
        isOpen={showModal}
        toggle={() => setShowModal(!showModal)}
        onConfirm={confirmStatusChange}
        status={selectedRow?.status}
      />
      {/* View Uploaded PDF */}
      {/* <ViewPDF
        fileType={"pdf_file"}
        titleName={watch("chapter_name")}
        isOpen={isPDFModal}
        toggleModal={togglePDFModal}
        images={watch("image_url")}
        docUploadView={true}
      /> */}
      <ViewImgAndPdf
        fileType={fileType}
        titleName={titleName}
        isOpen={modalOpen}
        toggleModal={toggleModal}
        images={modalImages}
        currentImageIndex={currentImageIndex}
        setCurrentImageIndex={setCurrentImageIndex}
      />
      {/* Delete Confirmation Modal */}
      <DeleteModal
        deleteRow={handleRowDelete}
        rowData={watch("rowDelete")}
        name={"E-Content"}
        deleteModal={watch("deleteModal")}
        toggleDeleteModal={() => setValue("deleteModal", false)}
        loading={false}
      />
    </>
  );
};

export default Index;
